var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "f7-page",
    {
      staticClass: "no-swipeback",
      attrs: { "login-screen": "", id: "login" },
      on: { "page:reinit": function ($event) {} },
    },
    [
      _c("a", { staticClass: "skip-link", attrs: { href: "#main-content" } }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t("accessibility.skip_to_main_content") ||
                "Aller au contenu principal"
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "body bgLogin" },
        [
          _c("b-row", { staticClass: "h-100" }, [
            _c("div", { staticClass: "loginPanel loginHeight" }, [
              _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticClass: "panel-heading ajust text-center mb-2rem" },
                    [
                      _c("b-col", { attrs: { cols: "2" } }),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "p-2", attrs: { cols: "8" } },
                        [
                          _c(
                            "span",
                            { staticClass: "navbar-brand mr-0 w-80" },
                            [
                              _c("img", {
                                staticClass: "heritage largescreen w-100",
                                attrs: {
                                  src: _vm.imgVarsLong,
                                  alt: "DealPrudence",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "p-0", attrs: { cols: "2" } },
                        [
                          _c(
                            "b-dropdown",
                            {
                              staticClass: "no-back",
                              attrs: {
                                left: "",
                                "toggle-class": "border-0 m-md-2 z-5",
                                variant: "light",
                              },
                              model: {
                                value: _vm.language,
                                callback: function ($$v) {
                                  _vm.language = $$v
                                },
                                expression: "language",
                              },
                            },
                            [
                              _c("template", { slot: "button-content" }, [
                                _c("img", {
                                  staticClass: "flag-nav d-none-min-1460px",
                                  attrs: {
                                    src:
                                      _vm.language === "FR"
                                        ? _vm.logoFlagFR
                                        : _vm.logoFlagEN,
                                    alt: "FR",
                                  },
                                }),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "flag-nav d-none-max-1459px",
                                  attrs: {
                                    src:
                                      _vm.language === "FR"
                                        ? _vm.logoFlagFR
                                        : _vm.logoFlagEN,
                                    alt: "",
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "d-none-max-1459px mr-1" },
                                  [_vm._v(_vm._s(_vm.labelLanguage))]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.langOptions, function (option) {
                                return _c(
                                  "b-dropdown-item",
                                  {
                                    key: option.value,
                                    staticClass: "dropdown-item-web-header",
                                    on: {
                                      click: function ($event) {
                                        return _vm.languageCountry(option.value)
                                      },
                                    },
                                  },
                                  [
                                    option.value === "FR"
                                      ? _c("img", {
                                          staticClass: "flag-nav",
                                          attrs: {
                                            src: _vm.logoFlagFR,
                                            alt: "",
                                          },
                                        })
                                      : _c("img", {
                                          staticClass: "flag-nav",
                                          attrs: {
                                            src: _vm.logoFlagEN,
                                            alt: "",
                                          },
                                        }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(option.text))]),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.mode === "confirmEmail"
                    ? _c(
                        "div",
                        {
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.registerUser()
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      id: "Login",
                                      inputType: "text",
                                      inputLabel: _vm.$t("common.eml_adrs"),
                                      inputClass: "inputLogin",
                                      specificErrorIndicator:
                                        _vm.credentials.LoginError,
                                      specificMessage:
                                        _vm.credentials.LoginErrorMessage,
                                    },
                                    model: {
                                      value: _vm.credentials.Login,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.credentials, "Login", $$v)
                                      },
                                      expression: "credentials.Login",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      id: "Token",
                                      inputType: "text",
                                      inputLabel: _vm.$t("common.login_token"),
                                      inputClass: "inputLogin",
                                      specificErrorIndicator:
                                        _vm.credentials.TokenError,
                                      specificMessage:
                                        _vm.credentials.TokenErrorMessage,
                                    },
                                    model: {
                                      value: _vm.credentials.Token,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.credentials, "Token", $$v)
                                      },
                                      expression: "credentials.Token",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mode === "register"
                    ? _c(
                        "div",
                        {
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.registerUser()
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      id: "Login",
                                      inputType: "text",
                                      inputLabel: _vm.$t("common.eml_adrs"),
                                      inputClass: "inputLogin",
                                      specificErrorIndicator:
                                        _vm.credentials.LoginError,
                                      specificMessage:
                                        _vm.credentials.LoginErrorMessage,
                                    },
                                    model: {
                                      value: _vm.credentials.Login,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.credentials, "Login", $$v)
                                      },
                                      expression: "credentials.Login",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "label",
                                      { attrs: { for: "password" } },
                                      [_vm._v(_vm._s(_vm.$t("common.pwd")))]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "d-flex" }, [
                                      _vm.credentials.PasswordFieldType ===
                                      "checkbox"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.credentials.Password,
                                                expression:
                                                  "credentials.Password",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials.PasswordError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.credentials.Password
                                              )
                                                ? _vm._i(
                                                    _vm.credentials.Password,
                                                    null
                                                  ) > -1
                                                : _vm.credentials.Password,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.credentials.Password,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.credentials,
                                                        "Password",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.credentials,
                                                        "Password",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.credentials,
                                                    "Password",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          })
                                        : _vm.credentials.PasswordFieldType ===
                                          "radio"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.credentials.Password,
                                                expression:
                                                  "credentials.Password",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials.PasswordError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: "radio",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.credentials.Password,
                                                null
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.credentials,
                                                  "Password",
                                                  null
                                                )
                                              },
                                            },
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.credentials.Password,
                                                expression:
                                                  "credentials.Password",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials.PasswordError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: _vm.credentials
                                                .PasswordFieldType,
                                            },
                                            domProps: {
                                              value: _vm.credentials.Password,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.credentials,
                                                  "Password",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "icon icon-password mt-2 pt-1",
                                        class: [
                                          _vm.isPasswordFieldHidden
                                            ? "fa-duotone fa-eye"
                                            : "fa-duotone fa-eye-slash",
                                        ],
                                        on: {
                                          click: _vm.togglePasswordVisibility,
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _vm.credentials.PasswordError
                                      ? _c(
                                          "div",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.credentials
                                                    .PasswordErrorMessage
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "label",
                                      { attrs: { for: "password" } },
                                      [_vm._v(_vm._s(_vm.$t("common.pwd")))]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "d-flex" }, [
                                      _vm.credentials
                                        .PasswordRepeatFieldType === "checkbox"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.credentials
                                                    .PasswordRepeat,
                                                expression:
                                                  "credentials.PasswordRepeat",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials
                                                .PasswordRepeatError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.credentials.PasswordRepeat
                                              )
                                                ? _vm._i(
                                                    _vm.credentials
                                                      .PasswordRepeat,
                                                    null
                                                  ) > -1
                                                : _vm.credentials
                                                    .PasswordRepeat,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.credentials
                                                      .PasswordRepeat,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.credentials,
                                                        "PasswordRepeat",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.credentials,
                                                        "PasswordRepeat",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.credentials,
                                                    "PasswordRepeat",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          })
                                        : _vm.credentials
                                            .PasswordRepeatFieldType === "radio"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.credentials
                                                    .PasswordRepeat,
                                                expression:
                                                  "credentials.PasswordRepeat",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials
                                                .PasswordRepeatError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: "radio",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.credentials.PasswordRepeat,
                                                null
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.credentials,
                                                  "PasswordRepeat",
                                                  null
                                                )
                                              },
                                            },
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.credentials
                                                    .PasswordRepeat,
                                                expression:
                                                  "credentials.PasswordRepeat",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials
                                                .PasswordRepeatError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: _vm.credentials
                                                .PasswordRepeatFieldType,
                                            },
                                            domProps: {
                                              value:
                                                _vm.credentials.PasswordRepeat,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.credentials,
                                                  "PasswordRepeat",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "icon icon-password mt-2 pt-1",
                                        class: [
                                          _vm.isPasswordRepeatFieldHidden
                                            ? "fa-duotone fa-eye"
                                            : "fa-duotone fa-eye-slash",
                                        ],
                                        on: {
                                          click:
                                            _vm.togglePasswordRepeatVisibility,
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _vm.credentials.PasswordRepeatError
                                      ? _c(
                                          "div",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.credentials
                                                    .PasswordRepeatErrorMessage
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm.mode === "confirmEmailSent"
                    ? _c("div", [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("loginPage.email_confirmation_mail_sent")
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  ["confirmEmail", "register"].includes(_vm.mode)
                    ? _c(
                        "b-row",
                        { staticClass: "loginButtons" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "8", offset: "2" } },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "primary",
                                    size: "lg",
                                    id: "submit-btn",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.registerUser()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("loginPage.create_account")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pt-3 pb-1" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "xs-12 text-center" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center",
                                },
                                [
                                  _c("img", {
                                    staticClass: "logoStreammind",
                                    attrs: {
                                      alt: "Streammind",
                                      src: _vm.logoStreammind,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("common.copyright"))
                                    ),
                                  ]),
                                  _vm._v(" \n                  "),
                                  _c("span", [_vm._v(_vm._s(_vm.version))]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }